import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TipoResolucion } from '../../models/t2_tiporesolucion.model';
import { TiposresolucionesService } from '../../services/tiposresoluciones.service';
import { environment } from './../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';

import $ from 'jquery';
import { RouterLink } from '@angular/router';
declare var bootstrap: any;

@Component({
  selector: 'app-admin-resoluciones',
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './admin-resoluciones.component.html',
  styleUrl: './admin-resoluciones.component.css'
})
export class AdminResolucionesComponent {

  public env = environment;

  usuarios: TipoResolucion[] = [];
  usuario: TipoResolucion = new TipoResolucion();
  usuario_find: TipoResolucion = new TipoResolucion();

  // Control de botones y estados
  btn: boolean = true;
  ready: boolean = false;
  searchTerm: string = '';
    
  // Paginación
  pages: any[] = [{}];
  pageActive: number = 1;
  pageSize: number = 20;

  // TipoResolucion logueado
  login_user: any;
  
  constructor(
    private auth: AuthService,
    private service: TiposresolucionesService,
    private toastr: ToastrService
  ){
    this.usuario_find = new TipoResolucion();
    this.login_user = this.auth.login_user;
  }
  
    ngOnInit(): void {
      //this.paginar();
    }
  
    paginar(){
      this.ready = false;
      this.usuario_find.Name = this.searchTerm;
      this.service.getPages(this.pageSize, this.usuario_find).subscribe(
        res => {
          console.log(res);
          if (res.length < this.pageActive) {
            if (this.searchTerm.trim() === "") {
              this.pageActive = res.length;
            } else {
              this.pageActive = 1;
            }
          }
          this.pages = res;
          this.getData(this.pageActive);
        },
        err => {
          console.error(err);
          this.ready = true;
          this.toastr.error('Error al cargar las páginas', 'Error');
        }
      );   
    }
  
    getData(page: number) {
      this.ready = false;
      this.pageActive = page;
      try {
          this.service.getDataFilter(this.pages[page - 1], this.usuario_find).subscribe(
            res => {
              console.log('TipoResolucions cargados:', res);
              this.usuarios = res;
              this.ready = true;
            },
            err => {
              console.error(err);
              this.ready = true;
              this.toastr.error('Error al cargar usuarios', 'Error');
            }
          );
      } catch (error) {
          console.error(error);
          this.pageActive -= 1;
          if (this.pageActive > 0) {
            this.service.getDataFilter(this.pages[this.pageActive - 1], this.usuario_find).subscribe(
              res => {
                this.usuarios = res;
                this.ready = true;
              },
              err => {
                console.error(err);
                this.ready = true;
                this.toastr.error('Error al cargar usuarios', 'Error');
              }
            );
          } else {
            this.ready = true;
          }
      }
      

    }

    closeForm(): void {
      const modalElement = document.getElementById('modalAdd');
      if (modalElement) {
        const modal = bootstrap.Modal.getInstance(modalElement) || new bootstrap.Modal(modalElement);
        modal.hide();
      }
      this.usuario = new TipoResolucion();
    }

    closeConfirm(): void {
      const modalElement = document.getElementById('modalEliminar');
      if (modalElement) {
        const modal = bootstrap.Modal.getInstance(modalElement) || new bootstrap.Modal(modalElement);
        modal.hide();
      }
      this.usuario = new TipoResolucion();
    }

    resetForm(): void {
      this.usuario = new TipoResolucion();
    }

    edit(usuario: TipoResolucion): void {
      this.usuario = {...usuario};
    }
  
    submit(): void {
      this.btn = false;
      if (this.usuario.Id==null) {
        // Crear nuevo usuario
        this.service.postData(this.usuario)
          .subscribe(
            (response) => {
              this.btn = true;
              this.toastr.success('Elemento creado exitosamente', 'Éxito');
              this.closeForm();
              this.paginar();
            },
            (error) => {
              this.btn = true;
              console.error('Error al crear elemento:', error);
              this.toastr.error('No se pudo crear el elemento', 'Error');
            }
          );
      } else {
        // Actualizar usuario existente
        this.service.putData(this.usuario)
          .subscribe(
            (response) => {
              this.btn = true;
              this.toastr.success('Elemento actualizado exitosamente', 'Éxito');
              this.closeForm();
              this.paginar();
            },
            (error) => {
              this.btn = true;
              console.error('Error al actualizar elemento:', error);
              this.toastr.error('No se pudo actualizar el elemento', 'Error');
            }
          );
      }
    }
  

    eliminar(usuario: any): void {
      if (usuario.Id) {
        this.btn = true;
        this.usuario = {...usuario};
      } else {
        this.btn = false;
        this.service.deleteData(this.usuario)
          .subscribe(
            (response) => {
              this.btn = true;
              this.toastr.success('Elemento eliminado exitosamente', 'Éxito');
              this.paginar();
              this.closeConfirm();
            },
            (error) => {
              console.error('Error al eliminar elemento:', error);
              this.btn = true;
              this.toastr.error('No se pudo eliminar el elemento', 'Error');
            }
          );
      }
    }
  
  
}
